import {$controller} from "rapid/index";
import {find, forEach} from "lodash";
import {countries} from "../../common/address/countries";
import {DeleteDialogController} from "../../common/delete-dialog/delete-dialog";
import DeleteDialogTemplate from "../../common/delete-dialog/delete-dialog.html";

const dependencies = ["$Company"];

class ClientSettingsController extends $controller {
  constructor($injector, $stateParams, $scope, $state, $ToastService, $UndoDeleteService) {
      "ngInject";
      super($injector, dependencies);
      this.$scope = $scope;
      this.$stateParams = $stateParams;
      this.$state = $state;
      this.toastService = $ToastService;
      this.undoDelete = $UndoDeleteService;

      let company;
      company = this.$Company.get({id: $stateParams.id});


      company && company.$promise
          .then((company) => {
              this.$scope.company = company;
          }).catch(() => {
              this.$state.go("clients");
          });
  }

  editClient(url) {
      let itemsArr = url.split("/");
      let itemId = itemsArr[itemsArr.length - 2];
      this.$state.go("clients.create", {id: itemId});
  }

  transformClientsArr(arr, title) {
      let newArr = [];
      forEach(arr, (user) => {
          newArr.push(`${user.first_name} ${user.last_name}`);
      });
      let str = newArr.length > 1 ? newArr.join(title ? "\n": ", ") : newArr.join("");
      return (str.length > 25 && !title) ? `${str.slice(0,25)} ...` : str;
    }

  updateCountry(country) {
      let newValue = find(countries, {code: country});
      if (newValue) {
          return newValue.name;
      }
      return null;
    }

    openDeleteDialog() {
        this.$mdDialog.show({
            title: "Deployment Delete",
            controller: DeleteDialogController,
            template: DeleteDialogTemplate,
            targetEvent: event,
            locals: {
                callback: () => {
                    this.deleteClient();
                },
                target: "company",
                item: this.$scope.company
            }
        });
    }

  deleteClient() {
      let client = this.$scope.company;
      client.$delete().then(() => {
          this.toastService.deleteToast(`Deleted client "${client.name}".`, () => {
              this.undoDelete.undoDelete("companies", this.$filter("getObjectId")(client.url)).then(() => {
                  this.toastService.showSimple(`Deletion undone`, 5000);
              }).catch(() => {
                  this.toastService.showError(`Could not undone deletion`, 5000);
              });
          });
          this.$state.go("clients");
      }).catch(() => {
          this.toastService.showError(`Could not delete client "${client.name}".`, 5000);
      });
  }
}

export default ClientSettingsController;


// WEBPACK FOOTER //
// ./sources/components/clients/client-settings/client-settings.controller.js